import {ColumnsType} from "antd/lib/table";
import {Direction, MenuCategoryDto} from "../../api";
import {CrudTable, nameof} from "digimuth-components/dist";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {Button} from "antd";
import {ArrowDownOutlined, ArrowUpOutlined} from "@ant-design/icons";
import styles from "./menuCategoryListContainer.module.scss";

export default function MenucategoriesList(props: MenuCategoriesProps) {
    const minPoistion = props.data? Math.min(...props.data.map(e => e.position!)) : 0;
    const maxPosition = props.data? Math.max(...props.data!.map(e => e.position!)) : 0;

    const columns: ColumnsType<MenuCategoryDto> = [
        {
            key: nameof<MenuCategoryDto>("position"),
            dataIndex: nameof<MenuCategoryDto>("position"),
            title: "Pozycja",
            render: (position, record) => <>
                <Button
                    style={position === minPoistion ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowUpOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Up)}
                />
                <Button
                    style={position === maxPosition ? {visibility: "hidden"} : {visibility: "visible"}}
                    icon={<ArrowDownOutlined/>}
                    onClick={() => props.onPositionChangeClicked!(record.id!, Direction.Down)}
                /></>
        },
        {
            key: nameof<MenuCategoryDto>("name"),
            dataIndex: nameof<MenuCategoryDto>("name"),
            title: "Nazwa kategorii"
        },
    ];
    return <>
        <Button type="primary" onClick={props.onAddClicked} className={styles.newMenuCategoryButton}>
            + Dodaj nową Kategorię Menu
        </Button>
        <CrudTable
            data={props.data}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            columns={columns}
            editButtonTitle="Edytuj"
            deleteButtonTitle="Usuń"
            deleteConfirmMessage="Czy na pewno chcesz usunąć tę kategorię?"
            cancelButtonTitle="Anuluj"
            actionsFixed={false}
            customRowActions={record =>
                <Button onClick={() => props.onShow(record.id!)}>
                    Pozycje menu
                </Button>
            }
            pagination={{showSizeChanger:true}}
        />
    </>
}

interface MenuCategoriesProps extends CrudTableWrapperProps<MenuCategoryDto> {
    onPositionChangeClicked: (id: number, direction: Direction) => void
    onShow: (id: number) => void
}
